// extracted by mini-css-extract-plugin
export default {"root":"LayoutSingleColumn_root__zqLIF","topbar":"LayoutSingleColumn_topbar__gw6OM","main":"LayoutSingleColumn_main__LwwW0"};